export const MILESTONE_STAGES = {
  RINSE_START: "RINSE_START",
  RINSE_END: "RINSE_END",
  MASH_START: "MASH_START",
  MASH_STEP_START: "MASH_STEP_START",
  MASH_MAINTAIN: "MASH_MAINTAIN",
  MASH_END: "MASH_END",
  LAUTERING_START: "LAUTERING_START",
  BOIL_HEATUP_START: "BOIL_HEATUP_START",
  BOIL_MAINTAIN_START: "BOIL_MAINTAIN_START",
  BOIL_HOP_DROP: "BOIL_HOP_DROP",
  BOIL_END: "BOIL_END",
  COOLING_START: "COOLING_START",
  COOLING_END: "COOLING_END",
  PITCH_COOLING_START: "PITCH_COOLING_START",
  FERMENTATION_START: "FERMENTATION_START",
  DRY_HOP_DROP: "DRY_HOP_DROP",
  CARBONATION_START: "CARBONATION_START",
  SERVING_START: "SERVING_START",
};

export const MILESTONE_SUB_TYPES = {
  HOP_DROP: "HOP_DROP",
  DRY_HOP: "DRY_HOP",
  TEMP_REACHED: "TEMP_REACHED",
};

export default MILESTONE_STAGES;
